// eslint-disable-next-line @typescript-eslint/no-explicit-any
const WINDOW_ENV = (window as any).env;
// eslint-disable-next-line import/prefer-default-export
export const sentryDsn: string = WINDOW_ENV?.SENTRY_DSN;
export const tracingRelease = `demo-${WINDOW_ENV?.VERSION || 'unknown'}`;
export const samplingRate: number = WINDOW_ENV?.SENTRY_SAMPLING_RANGE || 1.0;
